export const getTrendColor = (data: number[]) => {
  const first = data[0]
  const last = data[data.length - 1]

  if (first === last) {
    return "hsl(var(--muted-foreground))"
  }

  return last > first
    ? "hsl(var(--chart-positive))"
    : "hsl(var(--chart-negative))"
}
